import { render, staticRenderFns } from "./contratosSidebar.vue?vue&type=template&id=202a3c9a"
import script from "./contratosSidebar.vue?vue&type=script&lang=js"
export * from "./contratosSidebar.vue?vue&type=script&lang=js"
import style0 from "./contratosSidebar.vue?vue&type=style&index=0&id=202a3c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports